import { string } from 'yup';

export const jerseyNumberSchema = string()
  .nullable()
  .test('is-filled', 'Please fill out this field', (value) => !!value);
